import { render, staticRenderFns } from "./ChooseChapter.vue?vue&type=template&id=56cf1219&scoped=true&"
import script from "./ChooseChapter.vue?vue&type=script&lang=js&"
export * from "./ChooseChapter.vue?vue&type=script&lang=js&"
import style0 from "./ChooseChapter.vue?vue&type=style&index=0&id=56cf1219&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cf1219",
  null
  
)

export default component.exports